import onboardingPasso01Image from '../../assets/images/onboarding-passo-01-v3.webp';
import onboardingPasso02Image from '../../assets/images/onboarding-passo-02-v3.webp';
import onboardingPasso03Image from '../../assets/images/onboarding-passo-03-v4.webp';
import onboardingPasso04Image from '../../assets/images/onboarding-passo-04-v3.webp';
import onboardingPasso05Image from '../../assets/images/onboarding-passo-05-v3.webp';
import onboardingPasso06Image from '../../assets/images/onboarding-passo-06-v3.webp';
import onboardingPasso07Image from '../../assets/images/onboarding-passo-07-v4.webp';
import heroBackgroundImage from '../../assets/images/pagina-onboarding-across-secao-01-v9.jpg';
import mariMessageImage from '../../assets/images/pagina-black-mari-secao-03.webp';

export interface OnboardingHeroCopy {
  backgroundImageSrc: string;
  backgroundImageAlt: string;
  backgroundImagePosition?: string;
  backgroundImageTopCrop?: number;
  titleLineOne: string;
  titleLineTwo: string;
  bottomMessageLineOne: string;
  bottomMessageLineTwo: string;
  supportButtonLabel?: string;
  supportWhatsAppUrl?: string;
}

export const LANDPAGE_HERO: OnboardingHeroCopy = {
  backgroundImageSrc: heroBackgroundImage,
  backgroundImageAlt: 'Aluna recebida na consultoria Mariana Mósca',
  backgroundImagePosition: '100% center',
  titleLineOne: 'SEJA BEM-VINDA AO NOSSO',
  titleLineTwo: 'TIME DE ALUNAS',
  bottomMessageLineOne: 'É um prazer enorme ter você com a gente. Vamos começar?',
  bottomMessageLineTwo: 'Assista ao vídeo abaixo.',
  supportButtonLabel: 'SUPORTE',
  supportWhatsAppUrl:
    process.env.REACT_APP_LANDPAGE_SUPPORT_WHATSAPP_URL ??
    'https://api.whatsapp.com/send?phone=5521965749090',
};

export const LANDPAGE_WELCOME_VIDEO = {
  title: 'Vídeo de Boas-vindas',
  videoUrl: 'https://youtu.be/SPg_n9_NM7w',
  embedUrl: 'https://www.youtube.com/embed/SPg_n9_NM7w',
} as const;

export const LANDPAGE_SECTION_TITLE =
  'Passo a passo para você aproveitar o melhor da consultoria';

export type LandpageStepImagePosition = 'left' | 'right';

export interface LandpageConsultancyStepConfig {
  id: '01' | '02' | '03' | '04' | '05' | '06' | '07';
  stepLabel: string;
  stepTitle: string;
  stepDescription: string;
  imageSrc: string;
  imageAlt: string;
  imagePosition: LandpageStepImagePosition;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  secondaryDescription?: string;
}

export const LANDPAGE_CONSULTANCY_STEPS: readonly LandpageConsultancyStepConfig[] = [
  {
    id: '01',
    stepLabel: 'Passo 01',
    stepTitle:
      'Preenchimento da Anamnese e do Questionário de prontidão para atividade física',
    stepDescription:
      'Inicie respondendo nossa Anamnese e o Questionário de Prontidão (Par-Q) para atividade física. Isso nos ajudará a conhecer seu histórico e condições físicas, garantindo que seu plano de treino esteja alinhado aos seus objetivos.',
    imageSrc: onboardingPasso01Image,
    imageAlt: 'Aluna em treino de consultoria',
    imagePosition: 'right',
    primaryButtonLabel: 'ACESSAR ANAMNESE',
    secondaryButtonLabel: 'ACESSAR PAR-Q',
  },
  {
    id: '02',
    stepLabel: 'Passo 02',
    stepTitle: 'Envio de Fotos e Equipamentos',
    stepDescription:
      'Envie algumas fotos para o acompanhamento de sua evolução. A partir dessas imagens, vamos monitorar as mudanças e traçar estratégias específicas para você.',
    secondaryDescription:
      'Caso treine em casa ou academia de condomínio, informe também os equipamentos disponíveis no seu local de treino para personalizarmos ainda melhor o seu plano.',
    imageSrc: onboardingPasso02Image,
    imageAlt: 'Aluna enviando fotos de acompanhamento',
    imagePosition: 'left',
    primaryButtonLabel: 'ENVIAR FOTOS CORPORAIS',
    secondaryButtonLabel: 'EQUIPAMENTOS',
  },
  {
    id: '03',
    stepLabel: 'Passo 03',
    stepTitle: 'App da Consultoria',
    stepDescription:
      'O acesso ao aplicativo é feito com o e-mail da anamnese e a senha padrão Alun@123.\n\nImportante: seu treino será liberado após a conclusão da anamnese, do Par-Q e do envio das fotos, em até 4 dias úteis.',
    imageSrc: onboardingPasso03Image,
    imageAlt: 'Aluna utilizando o aplicativo da consultoria',
    imagePosition: 'right',
  },
  {
    id: '04',
    stepLabel: 'Passo 04',
    stepTitle: 'Recebimento dos Protocolos',
    stepDescription:
      'Aqui você recebe protocolos de estratégias nutricionais para diferentes objetivos! Utilize esses protocolos caso não tenha um Nutricionista Individualizado.',
    imageSrc: onboardingPasso04Image,
    imageAlt: 'Aluna recebendo protocolos da consultoria',
    imagePosition: 'left',
    primaryButtonLabel: 'BAIXAR PROTOCOLOS',
    secondaryButtonLabel: 'SOS CONSULTORIA',
  },
  {
    id: '05',
    stepLabel: 'Passo 05',
    stepTitle: 'Acesso à Comunidade Exclusiva',
    stepDescription:
      'Você agora faz parte da nossa comunidade!\n\nAqui, pode trocar experiências, tirar dúvidas e acessar conteúdos exclusivos da Mari.\n\nApresente-se ao entrar: nossas alunas são solícitas e vão adorar te conhecer.',
    imageSrc: onboardingPasso05Image,
    imageAlt: 'Aluna na comunidade exclusiva da consultoria',
    imagePosition: 'right',
    primaryButtonLabel: 'COMUNIDADE',
    secondaryButtonLabel: 'PODCASTS',
  },
  {
    id: '06',
    stepLabel: 'Passo 06',
    stepTitle: 'Suporte via WhatsApp',
    stepDescription:
      'Nosso time de suporte está disponível para você pelo WhatsApp, sempre pronto para atender dúvidas e dar suporte durante sua jornada.',
    imageSrc: onboardingPasso06Image,
    imageAlt: 'Aluna em contato com o suporte via WhatsApp',
    imagePosition: 'left',
    primaryButtonLabel: 'CONTATO COM SUPORTE',
  },
  {
    id: '07',
    stepLabel: 'Passo 07',
    stepTitle: 'Termos de uso e Políticas de Privacidade',
    stepDescription:
      'Leia o documento com atenção.\n\nDepois, clique em ACEITAR para concordar com os termos descritos.',
    imageSrc: onboardingPasso07Image,
    imageAlt: 'Aluna lendo termos de uso e políticas de privacidade',
    imagePosition: 'right',
    primaryButtonLabel: 'LER TERMOS',
  },
] as const;

export const LANDPAGE_MARI_MESSAGE = {
  imageSrc: mariMessageImage,
  imageAlt: 'Mariana Mósca',
  title: 'Minha mensagem para você:',
  paragraphsBeforeQuotes: [
    'Todo o processo de mudanças começa no nosso pensamento. Aquilo que penso, determina como eu me sinto. As emoções que eu sinto produzem as minhas ações. E essas ações vão produzir o meu resultado.',
    'A neurociência explica muito bem esse ciclo e por isso eu quero ter um combinado com você:',
    'Não importa se você está há 5 anos sem treinar, se está 10kg acima do peso, se está com pouca massa magra ou se quer apenas melhorar um pouco mais a composição corporal. Seu resultado começa com os pensamentos que você produz. Então escolha, todos os dias, reforçar os pensamentos positivos que vão te levar a ter as ações necessárias para mudar.',
  ],
  quotes: [
    'Eu vou chegar no melhor shape que já tive',
    'Eu vou ter uma velhice cheia de autonomia',
    'Meu corpo vai viver bem e sem dores',
    'Eu amo o momento de estar sozinha comigo mesma me dedicando ao treino',
  ],
  paragraphsAfterQuotes: [
    'Incorpore a mente de atleta, mesmo que você não seja uma. Se dedique. Você chegou até aqui por uma decisão e eu vou lembrá-la para que não desista de cuidar de você e possa viver de forma feliz e leve com seu corpo, sua mente e sua saúde.',
    'Conte comigo e com meu time.',
    'Com amor,',
  ],
  signature: 'Mari',
} as const;

export const LANDPAGE_FAQ = {
  backgroundText: 'FAQ',
  title: 'Perguntas Frequentes',
  copyright: 'Copyright © Mariana Mósca – Todos os direitos reservados',
  items: [
    {
      question: 'Onde envio minhas fotos?',
      answer:
        'Sua foto pode ser enviada no telefone do nosso suporte às alunas da Consultoria (21) 96574-9090.',
    },
    {
      question: 'A Mari me avisa quando o treino fica pronto?',
      answer:
        'Assim que seu treino estiver pronto entraremos em contato diretamente pelo WhatsApp para passar todas as orientações iniciais para o seu início no treinamento.',
    },
    {
      question: 'Preciso enviar fotos todo os meses?',
      answer:
        'As fotos comparativas devem ser enviadas a cada 3 meses. No suporte iremos te orientar a como fazer o comparativo de resultados.',
    },
    {
      question:
        'Consigo pedir um ajuste já que os treinos são personalizados treino metade em casa e metade academia?',
      answer:
        'Não. Os treinos são elaborados para apenas um local de treinamento por vez.\n\nCaso deseje trocar de ambiente (casa ou academia), basta avisar o suporte antes da renovação para que os ajustes necessários sejam realizados.',
    },
    {
      question: 'Como vou saber se meu treino já está no App?',
      answer:
        'Assim que seu treino estiver pronto você receberá uma notificação no APP (por isso é importante que mantenha as notificações push ativas) e um email com seu treino em PDF.',
    },
  ],
} as const;

export const LANDPAGE_COMMUNITY_LINKS = {
  communityUrl:
    process.env.REACT_APP_LANDPAGE_COMMUNITY_URL ??
    'https://chat.whatsapp.com/GXT1ivyHt5pGuBnQulNL7N',
  podcastsUrl:
    process.env.REACT_APP_LANDPAGE_PODCASTS_URL ??
    'https://chat.whatsapp.com/GOTzz8W7SFn2qCL1ylviIa',
} as const;

export const LANDPAGE_TERMS_PDF_VIEWER_URL =
  process.env.REACT_APP_LANDPAGE_TERMS_PDF_VIEWER_URL ??
  'https://lp.marimetreina.com.br/wp-admin/admin-ajax.php?action=get_viewer&file=https%3A%2F%2Flp.marimetreina.com.br%2Fwp-content%2Fuploads%2F2025%2F01%2FTermos-de-uso-e-politica-de-privacidade-2024.pdf&scrolling=0&selection_tool=0&spreads=-1#key=dGhlbWVNb2RlPWRlZmF1bHQmdG9vbGJhcj10cnVlJnBvc2l0aW9uPXRvcCZwcmVzZW50YXRpb249dHJ1ZSZsYXp5TG9hZD1mYWxzZSZkb3dubG9hZD10cnVlJmNvcHlfdGV4dD10cnVlJmFkZF90ZXh0PXRydWUmZHJhdz10cnVlJmFkZF9pbWFnZT10cnVlJnBkZl9yb3RhdGlvbj10cnVlJnBkZl9kZXRhaWxzPXRydWUmem9vbV9pbj10cnVlJnpvb21fb3V0PXRydWUmZml0X3ZpZXc9dHJ1ZSZib29rbWFyaz10cnVlJnNvdW5kPXRydWUmZmxpcGJvb2tfdG9vbGJhcl9wb3NpdGlvbj1ib3R0b20mc2VsZWN0aW9uX3Rvb2w9MCZzY3JvbGxpbmc9MCZzcHJlYWRzPS0xJmlzX3Byb19hY3RpdmU9MCZwYWdlTnVtYmVyPTEmd2F0ZXJtYXJrX3RleHQ9JndhdGVybWFya19mb250X3NpemU9NDgmd2F0ZXJtYXJrX2NvbG9yPSUyMzAwMDAwMCZ3YXRlcm1hcmtfb3BhY2l0eT0xNSZ3YXRlcm1hcmtfc3R5bGU9Y2VudGVy&zoom=50';

export const LANDPAGE_PROTOCOL_LINKS = {
  protocolsUrl:
    process.env.REACT_APP_LANDPAGE_PROTOCOLS_URL ??
    'https://drive.google.com/drive/u/0/folders/1B4jB_j-lpeO_OY4QsIAVNW5YpgrqSvV6',
  sosUrl:
    process.env.REACT_APP_LANDPAGE_SOS_URL ??
    'https://saber-prawn-7a3.notion.site/SOS-Consultoria-54668efc3b3c4e67867724c7f2efbdd2',
} as const;

export const LANDPAGE_APP_LINKS = {
  iosUrl:
    process.env.REACT_APP_LANDPAGE_IOS_APP_URL ??
    'https://apps.apple.com/br/app/across-performance/id1199999201',
  androidUrl:
    process.env.REACT_APP_LANDPAGE_ANDROID_APP_URL ??
    'https://play.google.com/store/apps/details?id=com.proyecto.acrossperformance.tgevo',
  tutorialUrl: process.env.REACT_APP_LANDPAGE_APP_TUTORIAL_URL ?? '',
} as const;

export const LANDPAGE_APP_STEP_BUTTONS = {
  apple: 'APPLE',
  android: 'ANDROID',
  tutorial: 'COMO USAR',
} as const;

export const LANDPAGE_APP_LOGIN_PREVIEW = {
  emailPlaceholder: 'Email',
  passwordPlaceholder: 'Senha',
  loginButtonLabel: 'Iniciar sessão',
} as const;

export const LANDPAGE_PHOTO_UPLOAD_PATH = '/onboarding/enviar-fotos';

export const LANDPAGE_PHOTO_GUIDELINES = {
  title: 'Como enviar suas fotos',
  intro:
    'Para o acompanhamento da sua evolução, envie fotos corporais nítidas, em ambiente iluminado e com o corpo inteiro visível.',
  positionsTitle: 'Fotos necessárias',
  positions: [
    'Frente — de frente para a câmera, braços levemente afastados do corpo.',
    'Costas — de costas para a câmera, braços levemente afastados do corpo.',
    'Lado direito — perfil do lado direito do corpo.',
    'Lado esquerdo — perfil do lado esquerdo do corpo.',
  ],
  tipsTitle: 'Dicas importantes',
  tips: [
    'Use roupas justas ou de academia para facilitar a avaliação.',
    'Evite filtros, sombras fortes e cortes no corpo.',
    'As imagens serão redimensionadas para Full HD antes do envio.',
  ],
  closeButton: 'Entendi',
} as const;
